import { deleteElementFromPath } from '../../object.util'
import Logger from '../../../services/logger.service'

export const deletePhoneAndEmailDetailFromPatientDemographics = (pcr: any): any => {
  try {
    deleteElementFromPath(pcr, 'patient.patientDemographics.number')
    deleteElementFromPath(pcr, 'patient.patientDemographics.phoneType')
    deleteElementFromPath(pcr, 'patient.patientDemographics.phoneDetail')
    deleteElementFromPath(pcr, 'patient.patientDemographics.email')
    deleteElementFromPath(pcr, 'patient.patientDemographics.emailType')
    deleteElementFromPath(pcr, 'patient.patientDemographics.emailDetail')
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule deletePhoneAndEmailDetailFromPatientDemographics ${error}`)
    throw error
  }
}
